import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-captcha-modal',
  templateUrl: './captcha-modal.component.html',
  styleUrls: ['./captcha-modal.component.scss'],
})
export class CaptchaModalComponent  {
  @Input() siteKey!: string;

  constructor(private modalCtrl: ModalController) {}

  onCaptchaResolved(token: string) {
    if (token) {
      this.modalCtrl.dismiss(token);
    }
  }

  close() {
    this.modalCtrl.dismiss(null);
  }
}